import axiosInstance from './api.config';

export const authAPI = {
  register: (data) => axiosInstance.post('/users/register/', data),
  login: (email, password) => axiosInstance.post('/users/login/', { email, password }),
  logout: () => axiosInstance.post('/users/logout/'),
  getProfile: () => axiosInstance.get('/users/profile/'),
  updateProfile: (data) => axiosInstance.patch('/users/profile/', data),
  changePassword: (data) => axiosInstance.post('/users/change-password/', data),
  checkEmail: (email) => axiosInstance.get(`/users/check-email/?email=${email}`),
};
